import React, { useEffect, useState } from "react";
import styles from "./event-description.module.css";
import { v4 } from "uuid";
import StandardRewardRow from "../../journey/standard-reward-row";
import { getJourneyTimeString } from "../../../functions/stringFunctions";
import { JOURNEY_STATUS_KEY_TYPE, LOCALES, REGION_ENG } from "../../../constants";
import { getUIText } from "../../../translation";
import getImageFileName from "../../../functions/getImageFileName";
import { loadData } from "../../../functions/dataLoader";

const multipleRegions = ["플로라", "칼라이드"];

export default function EventDescription({ lang, selected, desc, showEventName = true, isArcana = false }) {
    // const [journeyItems, setJourneyItems] = useState(null);

    // useEffect(() => {
    //     loadData("journey_items.json").then(journeyItems);
    // }, []);

    const hasChoices = selected.variants[0].choices.length > 1 || selected.variants[0].choices[0].name !== "";

    return (
        <div
            className={`${styles["event-descritpions"]} ${showEventName ? "" : `${styles["upper-line"]} ${styles["weather"]}`} ${
                isArcana ? `${styles["arcana"]}` : ""
            }`}
        >
            {showEventName && (
                <div className={styles["event-name"]}>{selected.name ? selected.name[lang] : selected.variants[0].name[lang]}</div>
            )}
            {(selected.times || multipleRegions.includes(desc.region)) && (
                <div className={styles["event-conditions"]}>
                    {selected.times.length > 0 &&
                        selected.times.map((time) => {
                            return (
                                <span className={`${styles["condition"]} ${styles["time"]}`} key={v4()}>
                                    {getJourneyTimeString(lang, time)}
                                </span>
                            );
                        })}
                    {multipleRegions.includes(desc.region) && (
                        <span className={`${styles["condition"]} ${styles["region"]}`}>
                            {lang === LOCALES.KO ? desc.region : REGION_ENG[desc.region]}
                        </span>
                    )}
                </div>
            )}
            <div className={styles["choices"]}>
                {/* 보상 */}
                {selected.variants[0].choices.map((choice, choiceIndex) => {
                    const choiceName = choice.name;
                    // console.log(selected.variants);
                    return (
                        <div className={styles["choice"]} key={v4()}>
                            {/* 이름+조건 */}
                            <div className={styles["choice-header"]}>
                                {choice.name !== "" && (
                                    <span className={styles["choice-name"]}>
                                        {hasChoices ? `${choiceIndex + 1}. ${choice.name[lang]}` : `${choice.name[lang]}`}
                                        {/* {index + 1}. {choice.name} */}
                                    </span>
                                )}
                            </div>
                            {/* 보상 */}
                            <div className={styles["rewards"]}>
                                {choice.success_rewards.length > 0 && (
                                    <div className={`${styles["reward-wrapper"]} ${styles["success"]}`} key={v4()}>
                                        {selected.variants.map((variant, variantIndex) => {
                                            const choice = variant.choices[choiceIndex];

                                            return (
                                                <div className={styles["reward-group"]} key={`choice_${choice.name["en-US"]}`}>
                                                    {(variant.difficultyKor || choice.condition) && (
                                                        <div className={styles["choice-condition"]}>
                                                            {variant.difficulties &&
                                                                variant.difficulties.map((difficulty) => (
                                                                    <div
                                                                        className={`${styles["badge"]} ${styles[difficulty[LOCALES.EN]]}`}
                                                                        key={`${choiceIndex}_difficulty_${difficulty[lang]}`}
                                                                    >
                                                                        {difficulty[lang]}
                                                                    </div>
                                                                ))}
                                                            {variant.battleNames && (
                                                                <div
                                                                    className={`${styles["badge"]} ${styles[variant.difficulties?.at(-1)?.[LOCALES.EN] ?? "normal"]}`}
                                                                >
                                                                    {variant.battleNames.map((e) => e[lang]).join(", ")}
                                                                </div>
                                                            )}
                                                            {choice.condition && (
                                                                <div className={`${styles["badge"]} ${styles["item"]}`}>
                                                                    {choice.condition.type === "RR_STAT" &&
                                                                        `${JOURNEY_STATUS_KEY_TYPE[choice.condition.target][lang]} ${choice.condition.value} ${getUIText(lang, "journey.event.condition.needed")}`}
                                                                    {choice.condition.type === "RR_STAMINA_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.useStamina")} ${choice.condition.value}`}
                                                                    {choice.condition.type === "RR_ITEM_CHECK" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(choice.condition.item.name[LOCALES.KO])}.webp`}
                                                                            />
                                                                            {lang === LOCALES.KO
                                                                                ? `${choice.condition.item.name[lang]} 보유`
                                                                                : `Have ${choice.condition.item.name[lang]}`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "RR_ITEM_USE" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(choice.condition.item.name[LOCALES.KO])}.webp`}
                                                                            />
                                                                            {lang === LOCALES.KO
                                                                                ? `${choice.condition.item.name[lang]} 소모`
                                                                                : `Use ${choice.condition.item.name[lang]}`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "RR_COIN_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.useCoin")} ${choice.condition.value}`}
                                                                    {choice.condition.type === "RR_PP_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.usePotentialPoint")}  ${choice.condition.value}`}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {choice.success_rewards.map((reward) => {
                                                        return (
                                                            <StandardRewardRow
                                                                lang={lang}
                                                                reward={reward}
                                                                difficulty={choice.difficultyKor}
                                                                reward_flag={"success"}
                                                                key={v4()}
                                                            />
                                                        );
                                                    })}
                                                    {variantIndex < selected.variants.length - 1 && (
                                                        <div className={styles["group-divider"]}>
                                                            {/* <hr /> */}
                                                            <span className={styles["success"]}>or</span>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {choice.success_rewards.length === 0 && (
                                    <div className={styles["reward-wrapper"]}>{getUIText(lang, "journey.event.reward.none")}</div>
                                )}
                                {choice.failure_rewards && choice.failure_rewards.length > 0 && (
                                    <div className={`${styles["reward-wrapper"]} ${styles["fail"]}`} key={v4()}>
                                        {selected.variants.map((variant, variantIndex) => {
                                            const choice = variant.choices[choiceIndex];

                                            return (
                                                <div className={styles["reward-group"]}>
                                                    {(variant.difficultyKor || choice.condition) && (
                                                        <div className={styles["choice-condition"]}>
                                                            {variant.difficulties &&
                                                                variant.difficulties.map((difficulty) => (
                                                                    <div
                                                                        className={`${styles["badge"]} ${styles[difficulty[LOCALES.EN]]}`}
                                                                        key={`${journey.name}_${choiceIndex}_difficulty_${difficulty[lang]}`}
                                                                    >
                                                                        {difficulty[lang]}
                                                                    </div>
                                                                ))}
                                                            {variant.battleNames && (
                                                                <div
                                                                    className={`${styles["badge"]} ${styles[variant.difficulties?.at(-1)?.[LOCALES.EN] ?? "normal"]}`}
                                                                >
                                                                    {variant.battleNames.map((e) => e[lang]).join(", ")}
                                                                </div>
                                                            )}
                                                            {choice.condition && (
                                                                <div className={`${styles["badge"]} ${styles["item"]}`}>
                                                                    {choice.condition.type === "RR_STAT" &&
                                                                        `${JOURNEY_STATUS_KEY_TYPE[choice.condition.target][lang]} ${choice.condition.value} ${getUIText(lang, "journey.event.condition.needed")}`}
                                                                    {choice.condition.type === "RR_STAMINA_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.useStamina")} ${choice.condition.value}`}
                                                                    {choice.condition.type === "RR_ITEM_CHECK" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(choice.condition.item.name[LOCALES.KO])}.webp`}
                                                                            />
                                                                            {lang === LOCALES.KO
                                                                                ? `${choice.condition.item.name[lang]} 보유`
                                                                                : `Have ${choice.condition.item.name[lang]}`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "RR_ITEM_USE" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(choice.condition.item.name[LOCALES.KO])}.webp`}
                                                                            />
                                                                            {lang === LOCALES.KO
                                                                                ? `${choice.condition.item.name[lang]} 소모`
                                                                                : `Use ${choice.condition.item.name[lang]}`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "RR_COIN_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.useCoin")} ${choice.condition.value}`}
                                                                    {choice.condition.type === "RR_PP_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.usePotentialPoint")}  ${choice.condition.value}`}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {choice.failure_rewards &&
                                                        choice.failure_rewards.map((reward) => {
                                                            if (!reward) return;
                                                            return (
                                                                <StandardRewardRow
                                                                    lang={lang}
                                                                    reward={reward}
                                                                    difficulty={choice.difficultyKor}
                                                                    reward_flag={"fail"}
                                                                    key={v4()}
                                                                />
                                                            );
                                                        })}
                                                    {variantIndex < selected.variants.length - 1 &&
                                                        selected.variants[variantIndex + 1].choices[choiceIndex].failure_rewards && (
                                                            <div className={styles["group-divider"]}>
                                                                {/* <hr /> */}
                                                                <span className={styles["success"]}>or</span>
                                                            </div>
                                                        )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {/* {choice.success_rewards.length === 0 && <div className={styles["reward-wrapper"]}>없음</div>} */}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
